var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.className,style:(_vm.genStyle),attrs:{"id":_vm.genName,"data-name":_vm.genName,"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"},domProps:{"innerHTML":_vm._s(_vm.icons[_vm.genName])}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc1380c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-icon/index.vue
// module id = kGPN
// module chunks = 23